import Ws from './ws'

const realtime = new Ws()

export default realtime
